import Icon from 'veui/components/Icon'
import { IconPaperPlane } from 'dls-icons-vue'

Icon.register('paper-plane', IconPaperPlane)
